import { render, staticRenderFns } from "./UpdatePackage.vue?vue&type=template&id=20f7bd02&scoped=true&"
import script from "./UpdatePackage.vue?vue&type=script&lang=js&"
export * from "./UpdatePackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f7bd02",
  null
  
)

export default component.exports